export const salts = {
    topic: 'da9ccd0c-bb37-48f6-8dad-623243c8f000',
}
